export const preferences = {
  mode: "Modo",
  text: "Texto",
  translationFeature: "Recurso de tradução",
};
